module.exports = __webpack_public_path__ + "img/model_22_zh.83ab3f3c.jpg";